module.exports = __webpack_public_path__ + "static/img/hosoda_03.33f3427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/hosoda_03.png
// module id = JYFF
// module chunks = 0